import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Pagination from "react-js-pagination";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import Radios from "./Radios";
import Input from "./Input";

import * as APIS from "../utils/service";
import consts from "../libs/consts"
import { setGroupData } from "../redux/communityStepSlice";
import { close, loadingflas, open } from "../redux/popupSlice";

const levelText = ['', '중개보조원', '공인중개사', '대표공인중개사'];

// 소모임 관리
const GatheringBoardManage = ({ setModalState }) => {
    const navigate = useNavigate();

    const [mangebtn, setManagebtn] = useState(1); // 탭 버튼 활성화 번호
    const [page, setPage] = useState(1);
    const [innerModal, setInnerModal] = useState(false); // 팝업 호출
    const [innerModalContent, setInnerModalContent] = useState({}); // 팝업 회원정보

    const [resignContent, setResignContent] = useState(""); // 팝업 텍스박스

    const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
    const isTablet = useMediaQuery({ query: "(min-width: 768px) and (max-width: 1024px)" });
    const isDesktop = useMediaQuery({ query: "(min-width: 1025px)" });

    const [limit, setLimit] = useState(3);
    //-----
    const dispatch = useDispatch();
    const { configdata } = useSelector(s => s.configReducer);
    const { groupData } = useSelector((s) => s.communityStepReducer);
    // menu1
    const [joinType, setJoinType] = useState(1); // 가입방식
    const [fileImg, setFileImg] = useState(""); // 첨부파일 데이터
    const [fileName, setFileName] = useState(""); // 첨부파일 이름
    const [textArea, setTextArea] = useState(""); // 소개
    const [groupInfo, setGroupInfo] = useState(null); // 그룹정보
    // menu2
    const [noticeList, setNoticeList] = useState([]) // 공지 리스트
    const [boardList, setBoardList] = useState([])
    // menu3
    const [userList, setUserList] = useState([]); // 사용자 리스트
    const [dismissal, setDismissal] = useState(false); // 탈퇴여부
    // menu4
    const [joinList, setJoinList] = useState([]);

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const fileRef = useRef();

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file?.name);
            const validFile = ["image/jpeg", "image/png", "image/jpg"];
            if (!validFile.includes(file?.type)) {
                messagePopup("이미지 파일만 업로드 가능합니다.")
                return;
            }
            const readers = new FileReader();
            readers.onload = () => {
                const result = readers.result;
                setFileImg(result);
                console.log(result);
            };
            readers.readAsDataURL(file);
        }
    };

    //메시지 팝업
    const messagePopup = (msg, title = '알림') => {
        dispatch(
            open({
                component: msg,
                title: title,
                button: "확인",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                },
            })
        );
    }

    // 카테고리 이름 변경 
    const cateToName = (type = 1, idx = 1) => {
        if (type === 1) {
            let findCate = configdata?.consts?.communityCategory1?.find(v => v?.idx == idx);
            if (findCate) {
                return findCate?.title
            }
        } else if (type === 2) {
            let findCate = configdata?.consts?.communityCategory2?.find(v => v?.idx == idx);
            if (findCate) {
                return findCate?.title
            }
        }
        return ""
    }

    // 소모임 정보 로드
    const loadDetail = () => {
        if (groupData) {
            APIS.postData('/v1/communityGroup/get', {
                idx: groupData?.idx
            }).then(({ data }) => {
                setGroupInfo(data);
                setTextArea(data?.desc);
                setJoinType(data?.join_type)
                if (data?.thumb) {
                    setFileImg(consts.s3url + "/" + data?.thumb);
                }
            }).catch(() => {
                setGroupInfo(null);;
            })
        }
    }

    // 저장하기
    const saveFunc = () => {
        if (mangebtn === 1) { // 기본정보
            let sender = {
                idx: groupInfo.idx,
                desc: textArea,
                join_type: joinType,
            }
            if (fileImg.indexOf(consts?.s3url) < 0) {
                if (fileName.split(".").length == 2) {
                    sender.thumb = {
                        base: fileImg,
                        ext: fileName.split(".")[1]
                    }
                }
            }
            console.log(sender);

            dispatch(
                open({
                    component: "저장 하시겠습니까?",
                    title: "기본정보 저장",
                    button: "확인",
                    buttonCencle: "취소",
                    titleviewer: true,
                    // wideOne: true,
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                        APIS.postData('/v1/communityGroup/edit', sender).then(({ data }) => {
                            messagePopup("저장 되었습니다.")
                        }).catch(({ response }) => {
                            const { data } = response;
                            messagePopup(data?.msg || "잠시 후 다시 시도하세요.")
                        })
                    },
                    onCancelPress: () => {
                        dispatch(close());
                    },
                })
            );

        }
    }

    // 소모임 신청정보 로드
    const loadJoinList = () => {
        if (groupData) {
            APIS.postData('/v1/communityGroup/joinList', {
                idx: groupData?.idx
            }).then(({ data }) => {
                setJoinList(data);
            }).catch(() => {
                setJoinList([]);
            })
        }
    }

    /**
     * / 링크 상태변경 
     * @param {*} linkIdx 링크 고유번호
     * @param {*} status 2수락 3거절 9=강퇴
     * @param {*} desc 강퇴일경우 설명
     */
    const joinFunc = (linkIdx, status, desc) => {
        let sender = {
            idx: linkIdx,
            status: status,
            g_idx: groupData?.idx,
        }

        if (status == 9 && desc) {
            sender.desc = desc
        }

        APIS.postData('/v1/communityGroup/joinUpdate', sender)
            .then(({ data }) => {
                if (mangebtn === 4) {
                    loadJoinList();
                } else if (mangebtn === 3) {
                    loadUserList(dismissal);
                }
            }).catch(({ response }) => {
                const { data } = response;
                messagePopup(data?.msg || "잠시 후 다시 시도하세요.")
            })
    }

    // 회원 리스트 로드
    const loadUserList = (isDismissal) => {
        if (groupData) {
            // dispatch(loadingflas({ loading: true }));
            APIS.postData('/v1/communityGroup/userList', {
                type: isDismissal ? 2 : 1,
                idx: groupData?.idx,
                g_idx: groupData?.idx,
            }).then(({ data }) => {
                setUserList(data);
            }).catch(() => {
                setUserList([]);
            }).finally(() => {
                // dispatch(loadingflas({ loading: false }));
            })
        }
    }

    // 강퇴목록/회원목록 전환
    const dismissalFunc = (active) => {
        if (dismissal) {
            setDismissal(false);
            loadUserList(false)
        } else {
            setDismissal(true);
            loadUserList(true)
        }
    }

    const unlockFunc = (linkIdx) => {
        let sender = {
            idx: linkIdx,
            status: 9,
            delete_user:true,
            g_idx: groupData?.idx,
        }

        dispatch(
            open({
                component: "해제 하시겠습니까?",
                title: "재가입 불가 해제",
                button: "확인",
                buttonCencle: "취소",
                titleviewer: true,
                // wideOne: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                    APIS.postData('/v1/communityGroup/joinUpdate', sender).then(({ data }) => {
                        loadUserList(dismissal);
                    }).catch(({ response }) => {
                        const { data } = response;
                        messagePopup(data?.msg || "잠시 후 다시 시도하세요.")
                    })
                },
                onCancelPress: () => {
                    dispatch(close());
                },
            })
        );
    }

    // 공지 리스트
    const loadNotiList = () => {
        let sender = {
            idx: groupData?.idx,
        }

        APIS.postData('/v1/communityGroup/notice', sender)
            .then(({ data }) => {
                setNoticeList(data);
            }).catch(({ response }) => {
                const { data } = response;
                messagePopup(data?.msg || "잠시 후 다시 시도하세요.")
            })
    }

    /**
     * 공지 설정
     * @param {*} idx 게시물 아이디
     * @param {*} isNotice 공지여부
     */
    const updateNotice = (idx, isNotice) => {
        let sender = {
            idx,
            g_idx: groupData?.idx,
            require: isNotice
        }

        APIS.postData('/v1/communityGroup/setNotice', sender)
            .then(({ data }) => {
                loadNotiList();
            }).catch(({ response }) => {
                const { data } = response;
                messagePopup(data?.msg || "잠시 후 다시 시도하세요.")
            })
    }

    // 게시물 리스트
    const loadBoardList = () => {
        let sender = {
            g_idx: groupData?.idx,
            page: 1,
            limit: 10000
        };

        APIS.postData('/v1/communityGroup/boadList', sender).then(({ data }) => {
            if (data) {
                setBoardList(data?.list)
            }
        }).catch(({ response }) => {
            const { data } = response;
            if (data?.msg) messagePopup(data?.msg)

        })
    }

    useEffect(() => {
        // 탭 변경
        setPage(1);
        if (mangebtn === 1) { // 기본정보
            loadDetail();
        } else if (mangebtn === 2) { // 공지
            loadNotiList();
            loadBoardList();
        } else if (mangebtn === 3) { // 회원
            loadUserList(dismissal);
        } else if (mangebtn === 4) { // 가입
            loadJoinList();
        }
    }, [mangebtn])


    const pageFilter = (data, index) => {
        let sIndex = (page - 1) * limit
        let eIndex = sIndex + limit
        return (index >= sIndex && index < eIndex)
    }

    return (
        <>
            <div className={`overlay_community2 ${innerModal ? "active" : ""}`}>
                <div className="modal_inner_modal_wrap">
                    <div className="modal_inner_modal">
                        <p>
                            {innerModalContent?.user?.compony?.title} {innerModalContent?.user?.name}{" "}{innerModalContent?.user?.rank}를 강퇴하시겠습니까?
                            강퇴 후에는 재가입이 불가합니다.
                        </p>
                        <p>재가입 불가 해제는 강퇴 목록 확인에서 해제할 수 있습니다.</p>
                        <div className="modal_inner_write">
                            <p>사유 입력</p>
                            <input
                                type="text"
                                value={resignContent}
                                onChange={(e) =>
                                    setResignContent(e.target.value)
                                }
                            />
                        </div>
                    </div>
                    <div className="btn_wrap">
                        <button
                            className="gray"
                            onClick={() => {
                                setInnerModal(false);
                                setResignContent("");
                            }}
                        >
                            닫기
                        </button>
                        <button className="red" onClick={() => {
                            joinFunc(innerModalContent?.idx, 9, resignContent)
                            setInnerModal(false);
                            setResignContent("");
                        }}>강퇴</button>
                    </div>
                </div>
            </div>

            <div className="community_modal_white_wrap">
                <div className="gathering_board_manage_header">
                    <p>
                        모두의매물 소모임 운영방침은 대한민국 법령을 절대
                        준수합니다. 모두의매물 소모임을 이용하여 중개 행위
                        방해·단합 등 법령에서 금지하는 행위를 하는 경우 해당
                        소모임은 별도 통보 없이 즉시 폐쇄 될 수 있으며, 이로인해
                        발생한 민·형사상의 책임은 온전히 모두의매물 소모임
                        운영자에게 있음을 알립니다.
                    </p>
                    <p>
                        ＊관계법령 : 공인중개사법 제33조(금지행위), 형법
                        제307조(명예훼손) 등
                    </p>
                </div>
                <div className="gathering_board_manage_content_wrap">
                    <div className="gathering_board_manage_btn">
                        <div
                            className={`${mangebtn === 1 && "active"}`}
                            onClick={() => {
                                setManagebtn(1);
                            }}
                        >
                            기본정보
                        </div>
                        <div
                            className={`${mangebtn === 2 && "active"}`}
                            onClick={() => {
                                setManagebtn(2);
                            }}
                        >
                            공지사항
                        </div>
                        <div
                            className={`${mangebtn === 3 && "active"}`}
                            onClick={() => {
                                setManagebtn(3);
                            }}
                        >
                            회원관리
                        </div>
                        <div
                            className={`${mangebtn === 4 && "active"}`}
                            onClick={() => {
                                setManagebtn(4);
                            }}
                        >
                            가입신청
                        </div>
                    </div>
                    <div className="gathering_board_manage_content">
                        {mangebtn === 1 && (
                            <>
                                <div className="gathering_one_line">
                                    <div className="title">
                                        <p>카테고리</p>
                                    </div>
                                    <div className="content">
                                        {cateToName(1, groupInfo?.cate1)}-{cateToName(2, groupInfo?.cate2)}
                                    </div>
                                </div>
                                <div className="gathering_one_line">
                                    <div className="title">
                                        <p>소모임명</p>
                                    </div>
                                    <div>{groupInfo?.title}</div>
                                </div>
                                <div className="gathering_one_line file">
                                    <div className="title">
                                        <p>대표사진</p>
                                        <p className="small_delete">
                                            권장 사이즈 : 800*800px <br />
                                            최대 10MB 이하
                                        </p>
                                    </div>
                                    <div className="file_wrap">
                                        <div className="file_img_wrap">
                                            <img src={fileImg ? fileImg : null} />
                                        </div>
                                        <div>
                                            <div className="file_name">
                                                {fileName}
                                            </div>
                                            <button onClick={() => {
                                                fileRef.current.click();
                                            }}>
                                                수정
                                            </button>
                                        </div>

                                        <input
                                            type="file"
                                            style={{ display: "none" }}
                                            ref={fileRef}
                                            onChange={handleFile}
                                        />
                                    </div>
                                </div>
                                <div className="gathering_one_line">
                                    <div className="title">
                                        <p>소개</p>
                                    </div>
                                    <div className="textarea_wrap">
                                        <textarea
                                            placeholder="최소 50글자 이상 작성해주세요."
                                            value={textArea}
                                            maxLength={2000}
                                            onChange={(e) =>
                                                setTextArea(e.target.value)
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="gathering_one_line">
                                    <div className="title">
                                        <p>가입방식</p>
                                    </div>
                                    <Radios
                                        linetype={"radioimg"}
                                        values={joinType}
                                        setvalues={setJoinType}
                                        namevalue={[{
                                            names: "가입 신청 시 바로 가입",
                                            values: 1,
                                        },
                                        {
                                            names: "운영진 승인 후 가입",
                                            values: 2,
                                        }]}
                                        fontweights={400}
                                        fontSizes={14}
                                        sizes={20}
                                        flexDirection={"column"}
                                        fontDispaly={"contents"}
                                        FlexWrap={"nowrap"}
                                        gap={"10px"}
                                    />
                                </div>
                                <div className="gathering_one_line">
                                    <div className="title">
                                        <p>최대인원</p>
                                    </div>
                                    <div className="content">
                                        {groupInfo?.max_count}명
                                    </div>
                                </div>
                            </>
                        )}
                        {mangebtn === 2 && (
                            <>
                                <div className="modal_announce_wrap">
                                    <p> 소모임에 게시 된 글을 지정하여 공지사항으로 등록할 수 있습니다. 새로운 공지사항을 원하시면 소모임에 게시글을 작성하고 지정하세요.</p>
                                    <div className="modal_announce_show">
                                        {noticeList?.map((item, index) => {
                                            return (
                                                <div className="modal_annouce">
                                                    <div className="title">
                                                        <div>공지</div>
                                                        <p>{item?.idx}</p>
                                                        <p>{item?.title}</p>
                                                    </div>
                                                    <div className="writer">
                                                        <p>{item?.user?.name} {item?.user?.rank}</p>
                                                        <img
                                                            onClick={() => {
                                                                updateNotice(item?.idx, false)
                                                            }}
                                                            src={`./images/icons/x-circle-white.svg`}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        {noticeList?.length < 1 && <p>목록이 없습니다.</p>}
                                    </div>
                                    <p>* 최대 3개까지 설정 가능합니다. 추가를 원하시면 기존 공지사항을 정리하세요.</p>
                                </div>
                                <p>게시글 목록</p>

                                <div className="board_table_wrap">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="small_delete" style={{ width: "10%" }}>번호</th>
                                                <th style={{ width: "25%" }}>제목</th>
                                                <th style={{ width: "10%" }}>작성자</th>
                                                <th className="small_delete" style={{ width: "10%" }}>작성일</th>
                                                <th className="small_delete" style={{ width: "10%" }}>조회수</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {boardList?.filter(pageFilter)?.map((item, i) => {
                                                return (
                                                    <tr key={"bl-it-" + i} style={{ cursor: "pointer" }} onClick={() => {
                                                        console.log("click!!")
                                                        window.open(`/GatheringContent?group=${item?.g_idx}&idx=${item?.idx}`)
                                                    }}>
                                                        <td className="small_delete">{item?.idx}</td>
                                                        <td>
                                                            <p>{item?.title}</p>
                                                        </td>
                                                        <td>
                                                            <p>{item?.user?.compony?.title}</p>
                                                            <p>{item?.user?.name} {item?.user?.rank}</p>
                                                        </td>
                                                        <td className="small_delete">{moment(item?.date).format("YYYY.MM.DD")}</td>
                                                        <td className="small_delete">{item?.view}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    <div className="PaginationContent">
                                        <Pagination
                                            className="my-pagination"
                                            activePage={page}// 현제 보고있는 페이지
                                            itemsCountPerPage={limit}// 한페이지에 출력할 아이템수
                                            totalItemsCount={boardList?.length}// 총 아이템수
                                            pageRangeDisplayed={5}// 표시할 페이지수
                                            onChange={handlePageChange}
                                            nextPageText=""
                                            prevPageText=""
                                            firstPageText=""
                                            lastPageText=""
                                        ></Pagination>
                                    </div>
                                </div>
                            </>
                        )}
                        {mangebtn === 3 && (
                            <>
                                <div className="board_table_wrap">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="" style={{ width: "20%" }} > 상호</th>
                                                <th className="small_phone_delete" style={{ width: "10%" }} >이름</th>
                                                <th className="small_delete" style={{ width: "10%" }} >직함</th>
                                                <th className="small_delete" style={{ width: "15%" }} >자격</th>
                                                <th className="small_delete" style={{ width: "15%" }} >가입승인일</th>
                                                <th style={{ width: "20%" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userList?.filter(pageFilter)?.map((item, idx) => {
                                                return (
                                                    <tr key={idx}>
                                                        <td className="td_title2" style={{ paddingLeft: "10px" }}>
                                                            <p>{item?.user?.compony?.title}</p>
                                                        </td>
                                                        <td className="small_phone_delete"><p>{item?.user?.name}</p></td>
                                                        <td className="small_delete">{item?.user?.rank}</td>
                                                        <td className="small_delete">{levelText[item?.user?.level]}</td>
                                                        <td className="small_delete">{moment(item.date).format("YYYY.MM.DD")}</td>
                                                        <td className="btn_wrap">
                                                            {!dismissal ? (
                                                                <>
                                                                    <button className="purple" style={{ flex: 6 }} onClick={() => {
                                                                        setModalState(false)
                                                                        navigate(`/GatheringBoard?group=${groupInfo.idx}`, { state: { searchName: item?.user?.name } })
                                                                    }}>게시글 보기</button>
                                                                    <button className="gray" style={{ flex: 4 }} onClick={() => {
                                                                        setInnerModal(true);
                                                                        setInnerModalContent(item);
                                                                    }}>강퇴</button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <button className="gray" style={{ flex: 4 }} onClick={() => {
                                                                        messagePopup(item?.no_desc || "-", "강퇴사유")
                                                                    }}>
                                                                        {isMobile ? "사유" : "강퇴 사유"}
                                                                    </button>
                                                                    <button className="purple" style={{ flex: 6 }} onClick={() => {
                                                                        unlockFunc(item?.idx)
                                                                    }}>
                                                                        {isMobile ? "불가 해제" : "재가입 불가 해제"}
                                                                    </button>
                                                                </>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            {userList?.length < 1 && <tr>
                                                <td colSpan={6}>목록이 없습니다.</td>
                                            </tr>}
                                        </tbody>
                                    </table>
                                    <div className="PaginationContent">
                                        <Pagination
                                            className="my-pagination"
                                            activePage={page} // 현재 보고있는 페이지
                                            itemsCountPerPage={limit} // 한페이지에 출력할 아이템수
                                            totalItemsCount={userList?.length} // 총 아이템수
                                            pageRangeDisplayed={5} // 표시할 페이지수
                                            onChange={handlePageChange} // 함수
                                            nextPageText=""
                                            prevPageText=""
                                            firstPageText=""
                                            lastPageText=""
                                        ></Pagination>
                                    </div>
                                </div>
                            </>
                        )}
                        {mangebtn === 4 && (
                            <>
                                <div className="board_table_wrap">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="" style={{ width: "20%" }}>상호</th>
                                                <th className="small_phone_delete" style={{ width: "10%" }}>이름</th>
                                                <th className="small_delete" style={{ width: "10%" }}>직함</th>
                                                <th className="small_delete" style={{ width: "15%" }}>자격</th>
                                                <th className="small_delete" style={{ width: "15%" }}>강퇴일</th>
                                                <th style={{ width: "20%" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {joinList?.filter(pageFilter)?.map((item, idx) => {
                                                return (
                                                    <tr key={idx}>
                                                        <td
                                                            className="td_title2"
                                                            style={{
                                                                paddingLeft:
                                                                    "10px",
                                                            }}
                                                        >
                                                            <p>{item?.user?.compony?.title}</p>
                                                        </td>
                                                        <td className="small_phone_delete">
                                                            <p>{item?.user?.name}</p>
                                                        </td>
                                                        <td className="small_delete">
                                                            {item?.user?.rank}
                                                        </td>
                                                        <td className="small_delete">
                                                            {levelText[item?.user?.level]}
                                                        </td>
                                                        <td className="small_delete">
                                                            {moment(
                                                                item?.date
                                                            ).format(
                                                                "YYYY.MM.DD"
                                                            )}
                                                        </td>
                                                        <td className="btn_wrap">
                                                            <button className="gray" onClick={() => {
                                                                joinFunc(item?.idx, 3)
                                                            }}>
                                                                거절
                                                            </button>
                                                            <button className="purple" onClick={() => {
                                                                joinFunc(item?.idx, 2)
                                                            }}>
                                                                승인
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            {joinList?.length < 1 && <tr>
                                                <td colSpan={6}>목록이 없습니다.</td>
                                            </tr>}
                                        </tbody>
                                    </table>
                                    <div className="PaginationContent">
                                        <Pagination
                                            className="my-pagination"
                                            // 현제 보고있는 페이지
                                            activePage={page}
                                            // 한페이지에 출력할 아이템수
                                            itemsCountPerPage={limit}
                                            // 총 아이템수
                                            totalItemsCount={joinList?.length}
                                            // 표시할 페이지수
                                            pageRangeDisplayed={5}
                                            // 함수
                                            onChange={handlePageChange}
                                            nextPageText=""
                                            prevPageText=""
                                            firstPageText=""
                                            lastPageText=""
                                        ></Pagination>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                {mangebtn === 3 && (
                    <div
                        className="dismissal_confirm"
                        onClick={dismissalFunc}
                    >
                        <img src={`./images/icons/chk_red.svg`} />
                        <p>{dismissal ? "회원 목록 확인" : "강퇴 목록 확인"}</p>
                    </div>
                )}

                <div className="bottom_btn_wrap">
                    {mangebtn === 1 && <button
                        className="register"
                        onClick={saveFunc}
                    >
                        저장
                    </button>}
                    <button
                        className="cancel"
                        onClick={() => setModalState(false)}
                    >
                        닫기
                    </button>
                </div>
            </div>
        </>
    );
};

export default GatheringBoardManage;
